import React from 'react'
import { Form } from './form'
import { Link } from 'react-router-dom'
import { X } from 'react-feather'
import styles from './content.module.css'
import { useViewport } from '../../../utils'
import { setPopupContent } from '../../../features/account/slice'
import { useInternationalization } from '../../../features/i18n'
import { useDispatch } from 'react-redux'
// import { LoginForm } from '../../../features/core/authentication/components/login-form'

const Content = ({required, embed, onClose, noRedirect}) => {
  const dispatch = useDispatch()
  const { translate } = useInternationalization()
  const { isDesktop } = useViewport()

  return (
    <div className={`w-full lg:w-10/12 mx-auto ${embed ? 'py-8' : 'min-h-screen'} h-full flex items-center`}>
      <div className={`w-full bg-white lg:rounded h-full lg:h-auto ${embed ? '' : 'relative'} ${embed ? '' : styles['wrapper']}`}>
        {
          embed ? (
            <p className="absolute top-0 right-0 p-5" onClick={onClose}>
              <X/>
            </p>
          ) : <>
            {
              isDesktop && <>
                <Link to="/" className="absolute top-0 right-0 p-5">
                  <X/>
                </Link>
              </>
            }
          </>
        }
        {
          required &&
          <div className="hidden lg:flex flex-wrap -mx-4 mb-10">
            <div className="w-1/2 px-4 ml-auto">
              <p className="text-gray-444 text-sm">To .... .... .... .... , please sign in.</p>
            </div>
          </div>
        }
        <div className="flex flex-wrap -mx-4">
          <div className="mx-auto lg:mx-0 w-1/2 px-4 h-auto pt-24">
            <img src="/images/khub_signup.png" alt="sign up" className="mb-5 lg:mb-0 mx-auto lg:mx-0 lg:mr-auto lg:w-10/12"/>
          </div>
          {
            required &&
            <div className="w-full lg:hidden mb-5 text-center">
              <p className="text-gray-444 text-sm text-center mx-auto">To .... .... .... .... , please sign in.</p>
            </div>
          }
          <div className="w-full md:w-10/12 md:mx-auto lg:mx-0 lg:w-1/2 px-4">
            <h1 className="text-3xl lg:text-4xl text-center lg:text-left font-bold font-accent mb-5 lg:mb-8 uppercase">
              {translate('AUTH', 'login')}
            </h1>

            {/* @todo: [nice to have] change form to the new one */}
            <Form className="mb-5 lg:mb-8" noRedirect={noRedirect} onClose={onClose} embed={embed}/>
            {/* <LoginForm className="lg:w-11/12 mb-5 lg:mb-8" /> */}

            <p className="text-center lg:text-left text-gray-444 text-sm">
              {translate('AUTH', 'dont_have_account')} {embed ? (
                <span onClick={() => dispatch(setPopupContent('register'))} className="text-secondary link underline">
                  {translate('AUTH', 'sign_up_now')}
                </span>
              ) : (
                <Link to="/register" className="text-secondary link underline">
                  {translate('AUTH', 'sign_up_now')}
                </Link>
              )}
            </p>
          </div>
        </div>

        <hr className={`${styles['separator']}`}/>

        <div className="text-center lg:text-lg mb-5 lg:mb-0 text-gray-444">
          {translate('AUTH', 'have_organization')} {embed ? (
            <span onClick={onClose}><Link to="/register-organization" className="text-secondary underline">
              {translate('AUTH', 'sign_up_here')}
            </Link></span>
          ) : (
            <Link to="/register-organization" className="text-secondary underline">
              {translate('AUTH', 'sign_up_here')}
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

export { Content }
